module.exports = __webpack_public_path__ + "static/calling-in-counseling-b1b3303378de63b4fa81165440e2757e.jpg";